import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
} from "reactstrap";

interface AlertModalProps {
  isOpen: boolean;
  toggle: () => void;
  message: string;
  onConfirm: (reason?: string) => void;
  onCancel: () => void;
  showReasonInput?: boolean;
}

const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  toggle,
  message,
  onConfirm,
  onCancel,
  showReasonInput = false,
}) => {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirm(showReasonInput ? reason : undefined);
    setReason("");
  };

  const handleCancel = () => {
    onCancel();
    setReason("");
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        {message}
        {showReasonInput && (
          <div className="mt-3">
            <Label for="reason">Reason:</Label>
            <Input
              type="textarea"
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter the reason for denying the request"
            />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleConfirm}>
          Yes
        </Button>
        <Button color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AlertModal;
